import { z } from "zod";

export const supplierUserSchema = z.object({
  id: z.number(),
  user: z.object({ id: z.number(), email: z.string(), name: z.string() }),
  supplier: z.number(),
  role: z.enum(["user", "supplier_admin", "department_admin"]),
  department: z.null(),
});

export type SupplierUser = z.infer<typeof supplierUserSchema>;

export const supplierUsersSchema = z.array(supplierUserSchema);

export type SupplierUsers = z.infer<typeof supplierUsersSchema>;
